export enum UserActionTypes {
  SET_SIGNED_IN = 'SET_SIGNED_IN',
  SET_ADMIN = 'SET_ADMIN',
  SET_USER_ROLES = 'SET_USER_ROLES',
  SET_USER_FEATURES = 'SET_USER_FEATURES',
  SET_USER_DATA = 'SET_USER_DATA',
  SET_TOKENS = 'SET_TOKENS',
  LOGOUT = 'LOGOUT',
  SET_USERS_DETAILS = 'SET_USERS_DETAILS',
}
